<template>
  <div>
    <div class="crumbs">
      <el-breadcrumb separator="/">
        <el-breadcrumb-item>宿舍人员列表</el-breadcrumb-item>
      </el-breadcrumb>
    </div>
    <el-card shadow="hover">
      <el-form :inline="true" size="small" v-model="listQuery">
        <el-form-item label="城市">
          <el-select v-model="listQuery.cityId" clearable placeholder="请选择城市" filterable @change="cityChange">
            <el-option v-for="(item, index) in cityList" :key="index" :label="item.city"
              :value="item.cityId + ''"></el-option>
          </el-select>
        </el-form-item>
        <!-- <el-form-item label="驿站名称">
          <el-select v-model="listQuery.postStationId" clearable placeholder="请选择驿站" filterable
            @change="postStationChange">
            <el-option v-for="(item, index) in postStationList" :key="index" :label="item.postStation"
              :value="item.postStationId + ''">
            </el-option>
          </el-select>
        </el-form-item> -->
        <el-form-item label="服务站名称">
          <el-select v-model="listQuery.serviceId" clearable placeholder="请选择服务站" filterable>
            <el-option v-for="(item, index) in stationList" :key="index" :label="item.station"
              :value="item.stationId + ''">
            </el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="宿舍编号">
          <el-input v-model="listQuery.dormNo" placeholder="请输入宿舍编号" clearable></el-input>
        </el-form-item>
        <!--        <el-form-item label="服务者编号">-->
        <!--          <el-input v-model="listQuery.teNo" placeholder="请输入服务者编号" clearable></el-input>-->
        <!--        </el-form-item>-->
        <el-form-item label="服务者姓名">
          <el-input v-model="listQuery.teName" placeholder="请输入服务者姓名" clearable></el-input>
        </el-form-item>
        <el-form-item label="审核人姓名">
          <el-input v-model="listQuery.auditPersonName" clearable></el-input>
        </el-form-item>
        <el-form-item label="离宿时间修改状态">
          <el-select v-model="listQuery.updateState" placeholder="请选择离宿时间修改状态" clearable>
            <el-option v-for="(item, index) in stateList" :key="index" :label="item" :value="index"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="住宿状态">
          <el-select v-model="listQuery.teAccom" placeholder="请选择住宿状态" clearable>
            <el-option v-for="(item, index) in teStateList" :key="index" :label="item" :value="index"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item>
          <el-button icon="el-icon-search" type="primary" plan @click="querySearch">查询</el-button>
          <el-button icon="el-icon-plus" type="primary" plan @click="alertCheckIn" v-per="'banlizhusu'">办理住宿
          </el-button>
        </el-form-item>

      </el-form>

      <!-- 列表数据 -->
      <el-table :data="listData" border style="width: 100%" class="table">
        <el-table-column type="index" label="序号" width="55"></el-table-column>
        <!--        <el-table-column prop="cityId" label="城市">-->
        <!--          <template slot-scope="scope">-->
        <!--            <span>{{ getCityName(scope.row.cityId) }}</span>-->
        <!--          </template>-->
        <!--        </el-table-column>-->
        <!--        <el-table-column prop="postStationId" label="驿站">-->
        <!--          <template slot-scope="scope">-->
        <!--            <span>{{ getPostStation(scope.row.postStationId) }}</span>-->
        <!--          </template>-->
        <!--        </el-table-column>-->
        <!--        <el-table-column prop="serviceId" label="服务站">-->
        <!--          <template slot-scope="scope">-->
        <!--            <span>{{ getStation(scope.row.serviceId) }}</span>-->
        <!--          </template>-->
        <!--        </el-table-column>-->
        <el-table-column prop="dormNo" label="宿舍编号" width="200px"></el-table-column>
        <el-table-column prop="teNo" label="商家编号"></el-table-column>
        <el-table-column prop="teName" label="商家姓名"></el-table-column>
        <el-table-column prop="teAccomValue" label="居住状态">
          <template slot="header">
            <el-tooltip content="入住或离宿时间晚于当天的，居住状态在第二日更新">
              <span>居住状态</span>
            </el-tooltip>
          </template>
        </el-table-column>
        <el-table-column prop="teLivetime" label="入住时间" min-width="140px"></el-table-column>
        <el-table-column prop="isFree" label="是否免住宿"  >
          <template slot-scope="scope">
            {{ scope.row.isFree==1?'是':'否' }}
          </template>
        </el-table-column>
        <el-table-column prop="teLivetime" label="免住宿时间" >
          <template slot-scope="scope" v-if="scope.row.isFree==1">
            {{ scope.row.freeStartDate  }} 至 <br/>{{ scope.row.freeEndDate  }}
          </template>
        </el-table-column>
        <el-table-column prop="teExpectLeavetime" label="预计离宿时间">
          <template slot="header">
            <el-tooltip content="想要修改成什么时候离宿">
              <span>预计离宿时间</span>
            </el-tooltip>
          </template>
        </el-table-column>
        <el-table-column prop="teLeavetime" label="离宿时间"></el-table-column>
        <el-table-column prop="updateStateValue" label="离宿时间修改状态"></el-table-column>
        <el-table-column prop="auditTime" label="离宿时间修改审核时间"></el-table-column>
        <el-table-column prop="auditPersonName" label="离宿时间修改审核人"></el-table-column>
        <!--        <el-table-column prop="auditRecommod" label="离宿时间修改审核人意见"></el-table-column>-->
        <el-table-column label="操作">
          <template slot-scope="scope">
            <el-button type="text" size="mini" @click="detail(scope.row)">详情</el-button>
            <!--                    <el-button type="text" size="mini" @click="alertEditDorm">编辑</el-button>-->
            <!--                    <el-button type="text" size="mini" v-if="scope.row.rentState===0" @click="ableOrDisable(scope.row.id,1)">启用-->
            <!--                    </el-button>-->
            <!--                    <el-button type="text" size="mini" v-if="scope.row.rentState===1" @click="ableOrDisable(scope.row.id,0)">停用-->
            <!--                    </el-button>-->
          </template>
        </el-table-column>

      </el-table>

      <!-- 分页 -->
      <pagination :total="total" :page.sync="currentPage" :limit.sync="pageSize"
        @pagination="queryList(currentPage, pageSize)" />
    </el-card>

    <el-dialog :visible.sync="showDetail" width="30%" :show-close=false>
      <el-descriptions class="margin-top" title="人员信息详情" border :column="4" direction="vertical">
        <template slot="extra">
          <el-dropdown :hide-on-click=false trigger="click">
            <span class="el-dropdown-link">
              更多操作<i class="el-icon-arrow-down el-icon--right"></i>
            </span>
            <el-dropdown-menu slot="dropdown">
              <el-dropdown-item @click.native="alertCheckOut(rowDetail)" v-if="!rowDetail.teLeavetime"
                v-per="'banlilisu'">办理离宿
              </el-dropdown-item>
              <el-dropdown-item v-if="this.rowDetail.updateCount === 0" @click.native="alertModityLeaveTime(rowDetail)"
                v-per="'xiugailisushijian'">修改离宿时间
              </el-dropdown-item>
              <el-dropdown-item v-if="this.rowDetail.updateState === 2" @click.native="alertAudit(rowDetail)"
                v-per="'shenhelisushijian'">时间
              </el-dropdown-item>
            </el-dropdown-menu>
          </el-dropdown>
        </template>
        <el-descriptions-item label="城市">{{ getCityName(this.rowDetail.cityId) }}</el-descriptions-item>
        <el-descriptions-item label="驿站">{{ getPostStation(this.rowDetail.postStationId) }}</el-descriptions-item>
        <el-descriptions-item label="服务站">{{ getStation(this.rowDetail.serviceId) }}</el-descriptions-item>
        <el-descriptions-item label="商家编号">{{ this.rowDetail.teNo }}</el-descriptions-item>
        <el-descriptions-item label="商家姓名">{{ this.rowDetail.teName }}</el-descriptions-item>
        <el-descriptions-item label="商家性别">{{ this.rowDetail.teGenderValue }}</el-descriptions-item>
        <el-descriptions-item label="当前是否可修改离宿时间">
          <el-tag>{{ checkCount(this.rowDetail.updateCount) }}
          </el-tag>
        </el-descriptions-item>
        <el-descriptions-item label="离宿类型">{{ this.rowDetail.teIncumValue }}</el-descriptions-item>
        <el-descriptions-item label="备注">{{ this.rowDetail.remark }}</el-descriptions-item>
        <el-descriptions-item label="离宿时间修改审核人意见">{{ this.rowDetail.auditRecommod }}</el-descriptions-item>
      </el-descriptions>
    </el-dialog>


    <el-dialog :visible.sync="showCheckIn" width="80%" title="办理住宿" :show-close=false>
      <el-form :inline="true" :model="checkInForm" class="demo-form-inline" label-width="100px" label-position="left"
        :rules="checkInFormRule" ref="checkInForm">
        <el-row :gutter="24">
          <el-col :span="6">
            <div class="grid-content bg-purple">
              <el-form-item label="宿舍" prop="dromId">
                <el-select v-model="checkInForm.dromId" clearable placeholder="请选择宿舍" filterable
                  @change="setCheckDormInfo">
                  <el-option v-for="(item, index) in dormList" :key="index" :label="joinChickDorm(item)"
                    :value="item.id">
                  </el-option>
                </el-select>
              </el-form-item>
            </div>
          </el-col>
          <!-- <el-col :span="6">
            <div class="grid-content bg-purple">
              <el-form-item label="宿舍所在城市" prop="cityId">
                <el-select v-model="checkInForm.cityId" clearable filterable disabled>
                  <el-option v-for="(item, index) in dormList" :key="index" :label="getCityName(item.cityId)"
                    :value="item.cityId"></el-option>
                </el-select>
              </el-form-item>
            </div>
          </el-col> -->
          <el-col :span="6">
            <div class="grid-content bg-purple">
              <el-form-item label="宿舍所在驿站" prop="postStationId">
                <el-select v-model="checkInForm.postStationId" clearable filterable disabled>
                  <el-option v-for="(item, index) in dormList" :key="index" :label="getPostStation(item.postStationId)"
                    :value="item.postStationId"></el-option>
                </el-select>
              </el-form-item>
            </div>
          </el-col>
          <el-col :span="6">
            <div>
              <el-form-item label="宿舍所在服务站" prop="serviceId" label-width="130px">
                <el-select v-model="checkInForm.serviceId" clearable filterable disabled>
                  <el-option v-for="(item, index) in dormList" :key="index" :label="getStation(item.serviceId)"
                    :value="item.serviceId"></el-option>
                </el-select>
              </el-form-item>
            </div>
          </el-col>

        </el-row>
        <el-row :gutter="24">
          <el-col :span="6">
            <div class="grid-content bg-purple">
              <el-form-item label="商家编号" prop="teNo">
                <el-select v-model="checkInForm.teNo" clearable filterable @change="setCheckPersonInfo">
                  <el-option v-for="(item, index) in personList" :key="index"
                    :label="item.workerNo + '--姓名：' + item.workerName + '--' + '服务站：' + item.station + ''"
                    :value="item.workerNo"></el-option>
                </el-select>
              </el-form-item>
            </div>
          </el-col>
          <el-col :span="6">
            <div>
              <el-form-item label="商家姓名">
                <el-select v-model="checkInForm.teName" clearable filterable disabled>
                  <el-option v-for="(item, index) in personList" :key="index" :label="item.workerName"
                    :value="item.workerName"></el-option>
                </el-select>
              </el-form-item>
            </div>
          </el-col>
          <el-col :span="6">
            <div>
              <el-form-item label="商家性别">
                <el-select v-model="checkInForm.teGender" clearable filterable disabled>
                  <el-option v-for="(item, index) in personList" :key="index" :label="item.gender"
                    :value="item.gender"></el-option>
                </el-select>
              </el-form-item>
            </div>
          </el-col>
          <el-col :span="6">
            <div>
              <el-form-item label="入住时间" prop="teLivetime">
                <el-date-picker v-model="checkInForm.teLivetime" type="date" placeholder="选择日期时间"
                  :picker-options={}></el-date-picker>
              </el-form-item>
            </div>
          </el-col>
        </el-row>
        <el-row>
          <el-col :span="6">
            <el-form-item label="是否免费入住" prop="isFree" label-width="120px">
              <el-radio-group v-model="checkInForm.isFree">
                <el-radio label="1">是</el-radio>
                <el-radio label="0">否</el-radio>
              </el-radio-group>
            </el-form-item>
          </el-col>
          <el-col :span="10" v-if="checkInForm.isFree=='1'">
            <el-form-item label="免住宿日期" label-width="90px">
              <el-date-picker style="width:300px" v-model="freeDate" value-format="yyyy-MM-dd" type="daterange"
                range-separator="至" start-placeholder="开始日期" end-placeholder="结束日期"></el-date-picker>
            </el-form-item>
          </el-col>
          <el-col :span="8">
            <el-form-item label="备注" label-width="50px" prop="remark">
              <el-input style="width:220px;" v-model="checkInForm.remark" type="textarea" :rows="3"></el-input>
            </el-form-item>
          </el-col>
        </el-row>
      </el-form>
      <span slot="footer" class="dialog-footer">
      <el-button type="primary" @click="checkIn('checkInForm')">提交</el-button>
      <el-button type="primary" @click="showCheckIn = false">取消</el-button>
      </span>
    </el-dialog>

    <el-dialog :visible.sync="showCheckOut" width="20%" title="办理离宿" :show-close=false>
      <el-form :inline="true" :model="checkOutForm" class="demo-form-inline" label-width="100px" label-position="left"
        :rules="checkOutRule" ref="checkOutForm">
        <el-form-item label="离宿时间" prop="leaveTime">
          <el-date-picker v-model="checkOutForm.leaveTime" type="date" placeholder="选择离宿时间"
            :picker-options="pickerOptions"></el-date-picker>
        </el-form-item>
        <el-form-item label="离宿原因类型" prop="teIncum">
          <el-select v-model="checkOutForm.teIncum" clearable filterable>
            <el-option v-for="(item, index) in leaveTypeList" :key="index" :label="item.name"
              :value="item.id"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="备注" prop="remark">
          <el-input v-model="checkOutForm.remark" type="textarea" :rows="4"></el-input>
        </el-form-item>
        <el-button type="primary" @click="checkOut('checkOutForm')">提交</el-button>
        <el-button type="primary" @click="showCheckOut = false">取消</el-button>
      </el-form>
    </el-dialog>

    <el-dialog :visible.sync="showModify" width="20%" title="修改离宿时间" :show-close=false>
      <el-form :inline="true" :model="modifyForm" class="demo-form-inline" label-width="100px" label-position="left"
        :rules="modifyFormRule" ref="modifyForm">
        <el-form-item label="离宿时间" prop="leaveTime">
          <el-date-picker v-model="modifyForm.leaveTime" type="date" placeholder="选择离宿时间"
            :picker-options="pickerOptions"></el-date-picker>
        </el-form-item>
        <el-button type="primary" @click="modifyLeaveTime('modifyForm')">提交</el-button>
        <el-button type="primary" @click="showModify = false">取消</el-button>
      </el-form>
    </el-dialog>

    <el-dialog :visible.sync="showAudit" width="20%" title="审核离宿时间" :show-close=false>
      <el-form :inline="true" :model="auditForm" class="demo-form-inline" label-width="100px" label-position="left"
        :rules="auditFormRule" ref="auditForm">
        <el-form-item label="审核结果" prop="auditState">
          <el-select v-model="auditForm.auditState" clearable filterable>
            <el-option v-for="(item, index) in auditStateList" :key="index" :label="item.name"
              :value="item.id"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="备注" prop="auditComment">
          <el-input v-model="auditForm.auditComment" type="textarea" :rows="4"></el-input>
        </el-form-item>
        <el-button type="primary" @click="audit('auditForm')">提交</el-button>
        <el-button type="primary" @click="showAudit = false">取消</el-button>
      </el-form>
    </el-dialog>


  </div>
</template>
<script>
import Pagination from "@/components/common/Pagination";
import service from "@/script/api/workercrmapi";
import moment from "moment";

let vm;
export default {
  components: { Pagination },
  data() {
    return {
      pickerOptions: {
        disabledDate(time) {
          return time.getTime() < Date.now() - 8.64e7;
        }
      },
      listData: [],
      cityList: [],
      allPostionList: [],
      allStationList: [],
      postStationList: [],
      stationList: [],
      total: 0,
      pageSize: 10,
      currentPage: 1, //当前页
      listQuery: {
        teName: this.$route.query.workerName,
        cityId: "",
        stationId: "",
        postStationId: "",
        dormNo: "",
        dromType: "",
        dromState: "",
        rentState: ""
      },
      stateList: {
        "1": "未修改",
        "2": "待审核",
        "3": "审核通过",
        "4": "审核不通过"
      }, auditStateList: [
        { id: 3, name: "审核通过" },
        { id: 4, name: "审核不通过" }
      ],
      teStateList: {
        "0": "待入住",
        "1": "现居住",
        "2": "曾入住"
      },
      showDetail: false,
      rowDetail: {},
      showCheckIn: false,
      freeDate: [],
      checkInForm: { dromId: "", isFree: '0' },
      checkInFormRule: {
        dromId: [
          { required: true, message: "请选择宿舍", trigger: "change" }
        ],
        teNo: [
          { required: true, message: "请选择商家", trigger: "change" }
        ],
        teLivetime: [
          { required: true, message: "请选择入住时间", trigger: "change" }
        ],
        isFree: [
          { required: true, message: "选择是否免住宿", trigger: "change" }
        ]
      },
      dormList: [],
      personList: [],
      showCheckOut: false,
      checkOutForm: {},
      showModify: false,
      modifyForm: {},
      showAudit: false,
      auditForm: {},
      checkOutRule: {
        leaveTime: [
          { required: true, message: "请选择离宿时间", trigger: "change" }
        ],
        teIncum: [
          { required: true, message: "请选择离宿原因类型", trigger: "change" }
        ]
      },
      leaveTypeList: [
        { id: "1", name: "解约" },
        { id: "2", name: "其他" }
      ],
      modifyFormRule: {
        leaveTime: [
          { required: true, message: "请选择离宿时间", trigger: "change" }
        ]
      },
      auditFormRule: {
        auditState: [
          { required: true, message: "请选择审核结果", trigger: "change" }
        ],
        auditComment: [
          { required: true, message: "请输入审核备注", trigger: "change" }
        ]
      }
    }
  },

  filters: {
    dateFormat(val) {
      return moment(val).format("YYYY-MM-DD");
    }
  }
  ,
  created() {
    this.queryAllPostStation();
    this.querySearch();
  }
  ,
  methods: {

    audit() {
      this.$refs.auditForm.validate((valid) => {
        if (valid) {
          service.$axiosAuditModifyLeaveTime(this.auditForm).then(res => {
            if (res.data.errno == 0) {
              this.showAudit = false;
              this.queryList();
            } else {
              this.$message.error(res.data.errmsg);
            }
          })
        } else {
          console.log("error submit!!!");
          return false;
        }
      });
    },

    alertAudit(detail) {
      this.showAudit = true;
      this.resetForm("auditForm");
      this.auditForm.checkInfoId = detail.id;

    },
    modifyLeaveTime() {
      this.$refs.modifyForm.validate((valid) => {
        if (valid) {
          this.modifyForm.leaveTime = moment(this.modifyForm.leaveTime).format("YYYY-MM-DD HH:mm:ss");
          service.$axiosUpdateCheckOutTime(this.modifyForm).then(res => {
            if (res.data.errno == 0) {
              this.showModify = false;
              this.queryList();
            } else {
              this.$message.error(res.data.errmsg);
            }
          })
        } else {
          console.log("error submit!!");
          return false;
        }
      });

    },
    alertModityLeaveTime(detail) {
      this.modifyForm = {};
      this.resetForm("modifyForm");
      this.showModify = true;
      this.modifyForm.checkInfoId = detail.id;
    },

    checkOut() {
      this.$refs.checkOutForm.validate((valid) => {
        if (valid) {
          this.checkOutForm.leaveTime = moment(this.checkOutForm.leaveTime).format("YYYY-MM-DD HH:mm:ss");
          service.$axiosCheckOut(this.checkOutForm).then(res => {
            if (res.data.errno != 0) {
              this.$message.error(res.data.errmsg);
            }
            this.showCheckOut = false;
            this.queryList();
          }).catch(err => {
            this.$message({
              message: "操作失败",
              type: "error"
            });
          });
        }
      });
    },
    alertCheckOut(detail) {
      this.resetForm("checkOutForm");
      this.showCheckOut = true;
      this.checkOutForm.checkInfoId = detail.id;
    },
    checkIn() {
      this.$refs.checkInForm.validate((valid) => {
        if (valid) {
          if(this.checkInForm.isFree==1){
              if(this.freeDate==null||this.freeDate.length==0){
                this.$message({
                  message: "请选择免入住日期",
                  type: "error"
                });
                return;
              }
              this.checkInForm.freeStartDate=this.freeDate[0];
              this.checkInForm.freeEndDate=this.freeDate[1];
          }
          this.checkInForm.teLivetime = moment(this.checkInForm.teLivetime).format("YYYY-MM-DD HH:mm:ss");
          let a = this.checkInForm.teGender;
          if (a === "男") {
            this.checkInForm.teGender = 1;
          } else if (a === "女") {
            this.checkInForm.teGender = 2;
          }
          service.$axiosCheckIn(this.deleteNullRelation(this.checkInForm)).then(res => {
            if (res.data.errno == 0) {
              this.$message({
                message: "入住成功",
                type: "success"
              });
              this.showCheckIn = false;
              this.queryList();
            } else {
              this.$message({
                message: res.data.errmsg,
                type: "error"
              });
            }
          }).catch(err => {
            this.$message({
              message: "入住失败",
              type: "error"
            });
          });
        } else {
          console.log("error submit!!");
          return false;
        }
      });
    },
    setCheckPersonInfo(id) {
      console.log(id);
      this.personList.forEach(item => {
        console.log(item.workerNo);
        if (item.workerNo == id) {
          this.checkInForm.teNo = item.workerNo;
          this.checkInForm.teName = item.workerName;
          this.checkInForm.teGender = item.gender;
        }
      })
    },
    setCheckDormInfo(id) {
      this.dormList.forEach(item => {
        if (item.id == id) {
          this.checkInForm.cityId = item.cityId;
          this.checkInForm.postStationId = item.postStationId;
          this.checkInForm.serviceId = item.serviceId;
        }
      })
    },
    queryPersonList() {
      service.$axiosQueryAssignCleaners().then(res => {
        this.personList = res.data.data;
      })
    },

    joinChickDorm(item) {
      return item.dromNo + " (" + item.dromAddr + "-限" + item.dromTypeName + "-" + this.getStation(item.serviceId) + "-" + item.canLiveNum + "空闲床位)";
    },
    resetForm(formName) {
      let a = this.$refs[formName];
      if (a !== null && a !== undefined) {
        a.resetFields();
      }
    },
    alertCheckIn() {
      this.checkInForm = {
        isFree:'0'
      };
      this.resetForm("checkInForm");
      this.showCheckIn = true;
      this.queryDormList();
      this.queryPersonList();
    },
    queryDormList() {
      let params = {
        dromState: 1,
        rentState: 1,
        size:100
      }
      service.$axiosGetDormitoryPageList(params).then(res => {
        this.dormList = res.data.data.list;
      })
    },
    checkCount(num) {
      return num === 1 ? "否" : "是";
    },
    detail(row) {
      this.showDetail = true;
      this.rowDetail = row;
    },
    deleteNullRelation(param) {
      let newParam = { ...param };
      for (let key in newParam) {
        if (newParam[key] === null || newParam[key] === '' || newParam[key] === undefined) {
          delete newParam[key];
        }
      }
      return newParam;
    },
    querySearch() {
      if (this.cityList.length === 0 || this.allPostionList.length === 0 || this.allStationList.length === 0) {
        this.queryAllPostStation();
      }
      this.queryList();
    },
    queryList(pageNum, pageSize) {
      let params = {
        pageNum: pageNum ? pageNum : 1,
        size: pageSize ? pageSize : 10,
        ...this.listQuery
      };
      service.$axiosGetDormitoryCheckInList(this.deleteNullRelation(params)).then(res => {
        this.listData = res.data.data.list;
        this.total = res.data.data.total;
      })
    }
    ,
    postStationChange() {
      this.listQuery.stationId = '';
      if (this.listQuery.postStationId != null && this.listQuery.postStationId !== '') {
        this.stationList = [];
        console.log(this.listQuery.postStationId);
        let postStationId = this.listQuery.postStationId;
        this.allStationList.filter(a => {
          if (a.postStationId == postStationId) {
            this.stationList.push(a);
          }
        })
      } else {
        this.stationList = this.allStationList.slice();
      }
    }
    ,
    cityChange() {
      console.log(this.listQuery.cityId);
      this.listQuery.postStationId = "";
      if (this.listQuery.cityId !== null && this.listQuery.cityId !== '') {
        this.postStationList = [];
        let cityId = this.listQuery.cityId;
        this.allPostionList.forEach(item => {
          if (item.cityId == cityId) {
            this.postStationList.push(item);
          }
        })
        this.stationList = [];
        this.allStationList.forEach(item => {
          if (item.cityId == cityId) {
            this.stationList.push(item);
          }
        })
      } else {
        this.postStationList = this.allPostionList.slice();
        this.stationList = this.allStationList.slice();
      }

    }
    ,
    postStationChange2() {
      this.addDormForm.stationId = "";
      let form = this.addDormForm;
      this.stationList = [];
      if (form.postStationId != null && form.postStationId !== '') {
        let postStationId = form.postStationId;
        this.allStationList.forEach(a => {
          if (a.postStationId == postStationId) {
            this.stationList.push(a);
          }
        })
        // console.log("this.stationList:"+JSON.stringify(this.stationList));
      } else {
        console.log(form.cityId);
        if (form.cityId != null && form.cityId !== '') {
          this.allStationList.forEach(a => {
            if (a.cityId == form.cityId) {
              this.stationList.push(a);
            }
          })
        } else {
          this.stationList = this.allStationList.slice();
        }

      }
    }
    ,
    cityChange2() {
      this.addDormForm.postStationId = "";
      let form = this.addDormForm;
      if (form.cityId !== null && form.cityId !== '') {
        this.postStationList = [];
        let cityId = form.cityId;
        this.allPostionList.forEach(item => {
          if (item.cityId == cityId) {
            this.postStationList.push(item);
          }
        })
        this.stationList = [];
        this.allStationList.forEach(item => {
          if (item.cityId == cityId) {
            this.stationList.push(item);
          }
        })
      } else {
        this.postStationList = this.allPostionList.slice();
        this.stationList = this.allStationList.slice();
      }

    }
    ,
    queryAllPostStation() {
      service.$axiosGetAllPostStation().then(res => {
        console.log(res.data.data);
        this.cityList = res.data.data.city;
        this.allPostionList = res.data.data.postStation;
        this.allStationList = res.data.data.station;
        this.postStationList = this.allPostionList.slice();
        this.stationList = this.allStationList.slice();
      });
    }
    ,
    getCityName(cityId) {
      let cityName = "";
      this.cityList.forEach(item => {
        if (item.cityId == cityId) {
          cityName = item.city;
        }
      })
      return cityName;
    }
    ,
    getPostStation(id) {
      let postStationName = "";
      this.allPostionList.forEach(item => {
        if (item.postStationId == id) {
          postStationName = item.postStation;
        }
      })
      return postStationName;
    }
    ,
    getStation(id) {
      let stationName = "";
      this.allStationList.forEach(item => {
        if (item.stationId == id) {
          stationName = item.station;
        }
      })
      return stationName;
    }
  },
  beforeCreate() {
    vm = this;
  }
}


</script>
<style scoped>
.crumbs {
  margin: 0 0 10px 0;
}

.btn-margin .el-button--small {
  margin: 10px 12px 0 0;
}

.el-image img {
  height: 60px;
  width: 60px;
  margin: 0 12px 12px 0;
  object-fit: cover;
}
</style>

<style>
.el-dropdown-link {
  cursor: pointer;
  color: darkseagreen;
}

.el-icon-arrow-down {
  font-size: 12px;
}
</style>
